<template>
  <div class="transfer-accounts-select">
    <span class="transfer-accounts-select-title">从账户</span>
    <el-select
      v-model="form.account1"
      size="mini"
      clearable
      :disabled="account1Dis"
      @change="handleChange($event,'1')"
      filterable
    >
      <el-option
        v-for="i in accountList1"
         :key="i.id"
         :disabled="i.dis"
         :label="i.name"
         :value="i.id">
       </el-option>
    </el-select>
    <div class="transfer-accounts-select-center">
      转到
    </div>
    <span class="transfer-accounts-select-title">账户</span>
    <el-select
      v-model="form.account2"
      size="mini"
      clearable
      :disabled="account2Dis"
      @change="handleChange($event,'2')"
      filterable
    >
      <el-option
        v-for="i in accountList2"
         :key="i.id"
         :disabled="i.dis"
         :label="i.name"
         :value="i.id">
       </el-option>
    </el-select>
  </div>
</template>

<script>
  export default {
    props:{
       list:[Array]
    },
    watch:{
      list:{
        handler(val) {
          if(val.length) {
            this.accountList1 = this.$lodash.cloneDeep(val);
            this.accountList2 = this.$lodash.cloneDeep(val);
          }
        },
        immediate:true,
        deep:true
      }
    },
    data() {
      return {
        form:{
          account1:"",
          account2:""
        },
        account1Dis:false,
        account2Dis:false,
        accountList1:[],
        accountList2:[]
      }
    },
    methods:{
      clearForm() {
        for(var i in this.form) {
          this.form[i] = "";
        }
         // 重置选项
        for(var i=1;i<3;i++) {
          let listText = 'accountList' + i;
          this[listText].forEach(i=>{
            i.dis = false;
          })
        }
      },
      setAccount(data) {
        this.form.account1 = data.transferOutAccountId;
        this.form.account2 = data.transferIntoAccountId;
        for(var i=1;i<3;i++) {
          let text = 'account' + i + "Dis";
          this[text] = true;
        }
      },
      handleChange(val,type) {
        this.form[('account'+type)] = val;
        let listText = 'accountList' + (type==1?2:1);
        this[listText].forEach(i=>{
          i.dis = false;
          if(i.id === val) {
            i.dis = true;
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .transfer-accounts-select {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &-center {
      margin: 0 20px;
      padding: 0px 20px 5px 15px;
      color: #333;
      font-size: 12px;
      background: url("../../../../../../static/icon/transformation.png") no-repeat;
      background-size: 100% 25%;
      background-position: bottom;
    }
    &-title {
      color: #FF6010;
      font-weight: 600;
      margin-right: 8px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/cashierdiaryTable/attr/transfer-accounts-select.vue